import { render, staticRenderFns } from "./tostart.vue?vue&type=template&id=a97291f8&scoped=true&"
import script from "./tostart.vue?vue&type=script&lang=js&"
export * from "./tostart.vue?vue&type=script&lang=js&"
import style0 from "./tostart.vue?vue&type=style&index=0&id=a97291f8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a97291f8",
  null
  
)

export default component.exports